import { render, staticRenderFns } from "./OrgChildStudio.vue?vue&type=template&id=9b161d7a&scoped=true"
import script from "./OrgChildStudio.vue?vue&type=script&lang=js"
export * from "./OrgChildStudio.vue?vue&type=script&lang=js"
import style0 from "./OrgChildStudio.vue?vue&type=style&index=0&id=9b161d7a&prod&scoped=true&lang=css"
import style1 from "./OrgChildStudio.vue?vue&type=style&index=1&id=9b161d7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b161d7a",
  null
  
)

export default component.exports